<template>
  <v-container fluid>
    <div class="padding-top">
      <div class="title">
        <h1>Please select which form you would like to fill out:</h1>
      </div>
      <v-layout>
        <v-flex xs12 pa-12 class="center padding-top">
          <v-btn color="success" large @click="goToBugs">Bug Form</v-btn>
          <v-btn color="success" large @click="goToProduct">Product Form</v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div class="padding-top" v-if="isInternal">
      <div class="title">
        <h1>Reports</h1>
      </div>
      <v-layout>
        <v-flex xs12 pa-12 class="center padding-top">
          <v-btn color="info" large @click="goToOptionsDashboard">Options Dashboard</v-btn>
          <v-btn color="info" large @click="goToIndustryDashboard">Industry Dashboard</v-btn>
          <v-btn color="info" large @click="goToSalesFunnel">Sales Funnel</v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div class="padding-top" v-if="isInternal">
      <div class="title">
        <h1>GHA Distribution Cutoff Logic</h1>
      </div>
      <v-layout>
        <v-flex xs12 pa-12 class="center padding-top">
          <v-btn color="info" large @click="goToDistribution">GHA Distribution Cutoff</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Home',
  data() {
    return {};
  },
  methods: {
    goToBugs() {
      this.$router.push({ name: 'BugForm' });
    },
    goToProduct() {
      this.$router.push({ name: 'ProductRequestForm' });
    },
    goToOptionsDashboard() {
      this.$router.push({ name: 'OptionsDashboard' });
    },
    goToIndustryDashboard() {
      this.$router.push({ name: 'IndustryDashboard' });
    },
    goToSalesFunnel() {
      this.$router.push({ name: 'SalesFunnel' });
    },
    goToDistribution() {
      this.$router.push({ name: 'DistributionForm' });
    }
  },
  computed: {
    ...mapState('account', ['user']),
    ...mapGetters('account', ['isInternal'])
  }
};
</script>

<style  lang='scss'>
@import './../style/_variables.scss';

.title {
  display: flex;
  justify-content: center;
}

.center {
  text-align: center;
}

.padding-top {
  padding-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue